import React from 'react';
import styled from 'styled-components';

const ArrowWrapper = styled.div<{ background?: string; color?: string, borderRadius?: string; padding?: string }>`
    padding: ${({ padding }) => padding || '6px 10px'};
    border-radius: ${({ borderRadius }) => borderRadius || '8px'};
    display: inline-block;
    color: ${({ color }) => color || '#fff'};
    background-color: ${({ background }) => background || '#000'};
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;

type IconProps = {
    background?: string;
    color?: string;
    width?: number;
    height?: number;
    borderRadius?: string;
    padding?: string;
    style?: any;
};

const ArrowIcon = ({ color, width, height }: IconProps) => (
    <svg width={width || '6'} height={height || '6'} viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 3L5 3" stroke={color || '#000'} />
        <path d="M2.35547 0.351562L5.00253 2.99862L2.35547 5.64568" stroke={color || '#000'} />
    </svg>
);

export const ArrowWithBg = ({ style, ...rest }: IconProps) => (
    <ArrowWrapper {...rest} style={style}>
        <ArrowIcon {...rest} />
    </ArrowWrapper>
)

export default ArrowIcon;
